// packages/eden-icons-raw/src/icons/alertFilled.js
var alertFilled = {
  type: "svg",
  props: {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  },
  metadata: {
    description: "Indicates an alert or error.",
    usage: "",
    category: "Alerts and Notifications",
    tags: ["error"]
  },
  children: [
    {
      type: "path",
      props: {
        d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM10.828 6.527l.188 7.562h1.968l.188-7.562h-2.344zm2.445 10.242c0-.688-.562-1.227-1.273-1.227-.71 0-1.273.54-1.273 1.227s.562 1.226 1.273 1.226c.71 0 1.273-.539 1.273-1.226z"
      }
    }
  ]
};
var alertFilled_default = alertFilled;
export {
  alertFilled_default as default
};
